import * as process from 'process';

/** Продакшен API — бейдж TEST не показываем */
const PROD_API_HOST = 'apelsin.smart-laboratory.ru';
/** Тестовый API — показываем бейдж TEST */
const TEST_API_HOST = 'test.apelsin.smart-laboratory.ru';

/**
 * Показывать ли метку TEST — только по хосту из `API_URL` в `.env` (DefinePlugin).
 */
export function shouldShowTestEnvironmentBadge(): boolean {
    const apiUrl = process.env.API_URL;
    if (!apiUrl?.trim()) {
        return false;
    }

    try {
        const { hostname } = new URL(apiUrl);
        const host = hostname.toLowerCase();
        if (host === PROD_API_HOST) {
            return false;
        }
        if (host === TEST_API_HOST) {
            return true;
        }
        return false;
    } catch {
        return false;
    }
}
